// extracted by mini-css-extract-plugin
export default {"NumericRangeFeature":"wf_a bhs_b bhs_we"};